import { render, staticRenderFns } from "./approvalsCommonDetail.vue?vue&type=template&id=62c5fbc7&scoped=true"
import script from "./approvalsCommonDetail.vue?vue&type=script&lang=js"
export * from "./approvalsCommonDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c5fbc7",
  null
  
)

export default component.exports